import { defineComponent as _defineComponent } from 'vue'
import type { MultiStepSportEvent } from '@/@types/graphql-types';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MotorsportEventCard',
  props: {
    event: null,
    expandOffers: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	event: MultiStepSportEvent;
	expandOffers?: boolean;
};



const fullPath = computed(() => props.event.parent?.content?.fullPath);

const eventName = computed(() => props.event.parent?.content?.name);

const eventParentName = computed(() => {
	const { name, number } = props.event.content?.competitionStage ?? {};
	if (name == null) return '';

	const nameCapitalised = `${name[0].toUpperCase()}${name.slice(1).toLowerCase()}`;
	return `${nameCapitalised} ${number ?? ''}`;
});

const startDateTime = computed(() => {
	const startAt = props.event.content?.startAt;
	return startAt == null ? null : new Date(props.event.content?.startAt);
});

const eventPath = computed(() => {
	const path = { path: fullPath.value, query: {} };
	if (process.client) {
		// for SEO purposes to prevent google from indexing the URL with the stage parameter.
		const { name, number } = props.event.content?.competitionStage;
		path.query = { stage: `${name} ${number || ''}` };
	}
	return path;
});

const componentContainer = computed(() => {
	if (fullPath.value) {
		return {
			cmp: 'router-link',
			props: { to: eventPath.value },
		};
	}

	return { cmp: 'div' };
});

return { __sfc: true,props, fullPath, eventName, eventParentName, startDateTime, eventPath, componentContainer }
}

})